import ActionCable from 'actioncable'

const CableWrapper = function (apiClient) {
  this.cable = null
  this.api = apiClient
}

/**
 * Return a promise Containing the cable consumer, instanciate it if necessary
 * @returns {Prmoise}
 */
CableWrapper.prototype.getCable = function () {
  const self = this
  if (!self.cable) {
    return self.api.get('/websocket/token').then(response => {
      self.cable = ActionCable.createConsumer(`${process.env.BASE_WEBSOCKET}/cable?token=${response.token}`)
      return self.cable
    })
  }
  return Promise.resolve(self.cable)
}
/**
 * Return a Promise containing cable subscriptions
 */
CableWrapper.prototype.getSubscriptions = function () {
  return this.getCable().then(cable => cable.subscriptions)
}

CableWrapper.prototype.disconnect = function () {
  if (this.cable) {
    this.cable.disconnect()
    this.cable = null
  }
}

export default CableWrapper
